import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  extendBankIdtitle: {
    defaultMessage: 'How to extend your BankID',
    id: 'ExtendBankId.title',
  },
  extendBankIdStepOne: {
    defaultMessage:
      'Log in to internetbanken or the Swedbank/Sparbanken Privat app using Mobile BankID or your security token',
    id: 'ExtendBankId.StepOne',
  },
  extendBankIdStepTwo: {
    defaultMessage: 'Click the menu option (on mobile device: the three dashes in the corner)',
    id: 'ExtendBankId.StepTwo',
  },
  extendBankIdStepThree: {
    defaultMessage: 'Select "Other services" and then "Mobile BankID"',
    id: 'ExtendBankId.StepThree',
  },
  extendBankIdStepFour: {
    defaultMessage: 'Activate extended BankID',
    id: 'ExtendBankId.StepFour',
  },
  extendBankIdStepFive: {
    defaultMessage:
      'Select the Mobile BankID to be extended. If you logged in with the Mobile BankID you want to extend, it is automatically pre-selected. Click continue',
    id: 'ExtendBankId.StepFive',
  },
  extendBankIdStepSix: {
    defaultMessage:
      'Select if you want to activate using a code card or card reader. Click continue.',
    id: 'ExtendBankId.StepSix',
  },
  extendBankIdStepSeven: {
    defaultMessage: 'Follow the instructions and activate with your code card or bank card reader.',
    id: 'ExtendBankId.StepSeven',
  },
  helpText: {
    defaultMessage:
      'If you encounter issues extending your BankID, visit {swedbankLink} or {sparbankenLink} for further instructions and support.',
    id: 'ExtendBankId.help',
  },
  extendBankIdbuttonText: {
    defaultMessage: 'Close',
    id: 'ExtendBankId.buttonText',
  },
  swedbankTitle: {
    defaultMessage:
      'To complete this payment and make it easier to pay invoices in the future, please extend your BankID with Swedbank',
    id: 'AccountsErrorOverlay.swedbankTitle',
  },
  swedbank: {
    defaultMessage:
      "If you don't have an internet banking payments service with Swedbank, you'll need to log in and activate it {DetailedErrorLink} before continuing.",
    id: 'AccountsErrorOverlay.swedbank',
  },
  here: {
    defaultMessage: 'here',
    id: 'AccountsErrorOverlay.here',
  },
  buttonText: {
    defaultMessage: 'Learn how to extend your BankID',
    id: 'AccountsErrorOverlay.buttonText',
  },
});
